
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.353 3.223a3.223 3.223 0 01-4.81 2.805l-3.63 5.012a4.005 4.005 0 011.354 3.258l2.678.495a2.352 2.352 0 11-.186.825l-2.632-.486a4.019 4.019 0 01-1.384 2.076l3.665 5.639a2.72 2.72 0 11-.688.493l-3.692-5.682a3.998 3.998 0 01-1.77.41c-.732 0-1.42-.197-2.012-.54l-3.061 4.333a3.223 3.223 0 11-.695-.48l3.074-4.352a4.005 4.005 0 01-1.32-2.976c0-.766.214-1.482.586-2.09L7.35 8.538a2.615 2.615 0 11.459-.713l4.536 3.465a4.004 4.004 0 012.915-1.253c.713 0 1.383.186 1.964.512l3.646-5.032a3.223 3.223 0 115.485-2.295z","fill":"#fff"}})])
          )
        }
      }
    